import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.title',
		defaultMessage: 'Reports',
		description: 'Navigation section title.',
	},
	allReports: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.all-reports',
		defaultMessage: 'All reports',
		description: 'Title for reports landing page navigation item',
	},
});
